<template>
  <div class="contain">
    <!-- 第一部分 -->
    <el-card class="box-card card-a">
      <div slot="header" class="clearfix" style="display: flex">
        <div style="height: 2.5rem" class="tab1">客户信息</div>
      </div>
      <div>
        <el-row>
          <el-col :span="24">
            <div class="choose">
              <div style="display: flex">
                <el-input v-model="projectName" placeholder="选择项目"></el-input>
                <el-button type="primary" style="margin-left: 1.25rem; height: 2.5rem"
                  @click="chooseProject">选择</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!-- 第二部分 -->
    <el-card class="box-card card-b">
      <div slot="header" class="clearfix" style="display: flex">
        <div style="height: 2.5rem" class="tab1">项目基本信息</div>
      </div>
      <div class="cunstomInfo">
        <el-row>
          <el-col :span="12"> 合同名称：{{ projectInfo.projectName }} </el-col>
          <el-col :span="12">合同编号：<span>{{ projectInfo.projectNo }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div style="display: flex">
              项目成员：
              <div style="display: flex">
                <div v-for="(item, index) in memberList" :key="index">
                  {{ item.nodeMemberName }}&nbsp;
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            立项日期：<span v-if="projectInfo.projectApprovalTime">{{
              projectInfo.projectApprovalTime | dataFormatT
            }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            预期结束日期：<span v-if="projectInfo.conclusionTime">{{
              projectInfo.conclusionTime | dataFormatT
            }}</span>
          </el-col>
          <el-col :span="12">
            实际结束日期：<span v-if="projectInfo.actualConclusionTime">{{
              projectInfo.actualConclusionTime | dataFormatT
            }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div style="display: flex">
              节点成员：
              <div>
                <div v-for="(list, index) in stepList" :key="index" style="display: flex">
                  {{ list.nodeName }}:&nbsp;&nbsp;
                  <div v-for="(item, index) in list.projectNodesMemberList" :key="index">
                    {{ item.nodeMemberName }},
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!-- 第三部分 -->
    <!-- <div v-if="projectInfo.projectName != ''"> -->
    <el-card class="box-card card-c">
      <div slot="header" style="display: flex; justify-content: space-between">
        <div style="height: 2.5rem" class="tab1">投诉列表</div>
        <div style="height: 2.5rem" class="tab2" @click="goComplaint">
          我要投诉
        </div>
      </div>
      <div style="height: 600px">
        <el-scrollbar style="height: 95%; width: 100%">
          <el-table :data="tableDataTwo" border style="width: 100%">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="projectName" label="项目名称" align="center">
            </el-table-column>
            <el-table-column prop="respondentName" label="被投诉人" align="center">
            </el-table-column>
            <el-table-column prop="complaintContent" label="投诉内容" align="center">
            </el-table-column>
            <el-table-column prop="createDt" label="投诉时间" align="center">
            </el-table-column>
            <el-table-column prop="dealContent" label="处理回执" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.dealContent">{{
                  scope.row.dealContent
                }}</span>
                <span v-if="!scope.row.dealContent">未填写</span>
              </template>
            </el-table-column>
            <el-table-column prop="createorName" label="处理时间" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.dealTime">{{
                  scope.row.dealTime | dataFormat
                }}</span>
                <span v-if="!scope.row.dealTime">-----</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status === '1'">已处理</span>
                <span v-if="scope.row.status === '0'">未处理</span>
                <span v-if="scope.row.status === '2'">已撤销</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="分配人选" placement="bottom">
                  <span style="color: #008eff" @click="toHandle(scope.row)" v-if="scope.row.status === '0'">处理</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
        <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
          :current-page.sync="queryInfo1.currPage" :page-sizes="[200, 50, 20, 10]" :page-size="queryInfo1.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total1" next-text="下一页" prev-text="上一页">
        </el-pagination>
      </div>
    </el-card>
    <!-- </div> -->

    <!-- 选择项目对话框 -->
    <el-dialog title="选择项目" :visible.sync="dialogVisible" width="50%" @close="closeChooseDia">
      <el-form :model="searchInput" label-width="5rem">
        <div style="padding: 1.25rem">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="项目名称">
                <el-input v-model="searchInput.projectName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="success" @click="search">查询</el-button>
            </el-col>
          </el-row>
          <div style="height: 450px">
            <el-scrollbar style="height: 90%; width: 100%">
              <el-table :data="tableData" style="width: 100%" @row-click="singleElection" highlight-current-row border>
                <el-table-column align="center" width="50" label="选择">
                  <template slot-scope="scope">
                    <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                    <el-radio class="radio" v-model="templateSelection" :label="scope.row.id">&nbsp;</el-radio>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="projectName" label="项目名称">
                </el-table-column>
                <el-table-column align="center" prop="businessDirectorName" label="商务负责人">
                </el-table-column>
                <el-table-column align="center" prop="startTime" label="立项时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createDt | dataFormatT }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="endTime" label="结项时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.conclusionTime | dataFormatT }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="pprojectTime" label="工期"></el-table-column>
              </el-table>
            </el-scrollbar>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="queryInfo.currPage" :page-sizes="[200, 10, 20, 30, 50]"
              :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="total"></el-pagination>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectConfirm">选 择</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 选择项目对话框 -->
    <!-- 我要投诉对话框 -->
    <el-dialog title="我要投诉" :visible.sync="dialogVisibleComplaint" width="30%" @close="closeComplaintDia">
      <div style="padding: 10px; box-sizing: border-box">
        <el-form ref="form" :model="formComplaint" label-width="80px">
          <el-form-item label="项目成员">
            <el-select v-model="formComplaint.respondentCode" placeholder="请选择要投诉的项目成员">
              <el-option :label="item.nodeMemberName" :value="item.nodeMemberCode" v-for="(item, index) in memberList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="投诉标题">
            <el-input v-model="formComplaint.complaintTitle" placeholder="请输入投诉标题"></el-input>
          </el-form-item>
          <el-form-item label="投诉内容">
            <el-input type="textarea" :rows="6" v-model="formComplaint.complaintContent"
              placeholder="请输入投诉内容"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleComplaint = false">取 消</el-button>
        <el-button type="primary" @click="submitComplaint">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 我要投诉对话框 -->
    <!-- 处理对话框 -->
    <el-dialog title="我要投诉" :visible.sync="dialogVisibleHandle" width="30%" @close="closeHandletDia">
      <div style="padding: 10px; box-sizing: border-box">
        <el-form ref="form" :model="formHandle" label-width="80px">
          <el-form-item label="项目成员">
            <el-select v-model="formHandle.status">
              <el-option :label="item.label" :value="item.value" v-for="(item, index) in handleList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="投诉内容">
            <el-input type="textarea" :rows="6" v-model="formHandle.dealContent" placeholder="请输入处理内容"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleHandle = false">取 消</el-button>
        <el-button type="primary" @click="submitHandle">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 处理对话框 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardTwo: "one",
      form: {},
      date: "",
      endDate: "",
      remark: "",
      stepList: [],
      projectName: "",
      formP: {},
      dialogVisible: false,
      tableData: [
        {
          id: "0001",
          projectName: "佰草园",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0002",
          projectName: "佰草园1",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0003",
          projectName: "佰草园2",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0004",
          projectName: "佰草园3",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
      ],
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
      // 项目信息
      projectInfo: {
        projectName: "",
      },
      tableDataTwo: [],
      // 项目表格分页
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 50,
        //查询条件
        condition: {
          id: "",
          projectName: "",
        },
      },
      // 责任人表格分页
      queryInfo1: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 50,
        //查询条件
        condition: {
          projectCode: "",
        },
      },
      total: 0,
      total1: 0,
      searchInput: {},
      searchInput1: {},
      dialogVisibleComplaint: false,
      formComplaint: {},
      memberList: [],
      handleList: [
        {
          value: '1',
          label: '处理完成'
        },
        {
          value: '2',
          label: '撤销投诉'
        }
      ],
      formHandle: {
        status: '1'
      },
      dialogVisibleHandle: false,
      complaintCode: "",//操作行的code
    };
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.projectName = this.searchInput.projectName;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    search1() {
      this.queryInfo1.condition.name = this.searchInput1.name;
      this.getTableData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange1(newSize) {
      this.queryInfo1.pageSize = newSize;
      this.getTableData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange1(newSize) {
      this.queryInfo1.currPage = newSize;
      this.getTableData();
    },
    // 查询项目
    getListData() {
      this.queryInfo.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      this.$http.post("/project/list", this.queryInfo).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.total = res.data.data.count;
          this.queryInfo.currPage = res.data.data.currPage;
          this.tableData = res.data.data.data;
          this.dialogVisible = true;
        }
      });
    },
    chooseProject() {
      this.getListData();
      // this.dialogVisible = true;
    },
    // 选择项目
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = this.tableData.filter((item) => item.id === row.id);
      console.log(`该行的id为${row.id}`, this.checkList);
    },
    // 确认选择
    selectConfirm() {
      //   this.projectInfo = this.checkList[0];
      this.dialogVisible = false;
      this.getStepsList();
      this.getTableData();
    },
    // 关闭对话框
    closeChooseDia() {
      this.tableData = [];
      this.queryInfo.currPage = 1;
      this.queryInfo.pageSize = 200;
      this.projectName = "";
    },
    // 查询项目节点
    getStepsList() {
      let sendData = {};
      sendData.projectCode = this.checkList[0].projectCode;
      this.$http
        .post("/project/loadProjectProgressInfo", sendData)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == 200) {
            this.projectInfo = res.data.data;
            this.stepList = res.data.data.projectNodesList;
            this.memberList = res.data.data.projectNodesMemberList;
            // for (var i = 0; i < this.stepList.length; i++) {
            //   // this.stepList[i].expectFinishTime= ""
            //   if (this.stepList[i].projectNodesMemberList.length == 0) {
            //     this.stepList[i].projectNodesMemberList.push({
            //       nodeMemberName: "",
            //     });
            //   }
            // }
          }
        });
    },
    getTableData() {
      var that = this;
      that.queryInfo1.condition.projectCode = this.checkList[0].projectCode;
      that.$http
        .post("/projectComplaint/list", that.queryInfo1)
        .then(function (response) {
          console.log("列表===>", response.data.data);
          if (response.data.code == 200) {
            that.total1 = response.data.data.count;
            that.queryInfo1.currPage = response.data.data.currPage;
            that.tableDataTwo = response.data.data.data;
            for (let i = 0; i < response.data.data.data.length; i++) {
              that.tableDataTwo[i].createDt = that.timeFormate(
                response.data.data.data[i].createDt
              );
            }
          }
        });
    },
    // 时间格式化
    timeFormate(originVal) {
      const dt = new Date(originVal);

      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");

      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      // yyyy-mm-dd hh:mm:ss
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    // 我要投诉
    goComplaint() {
      this.dialogVisibleComplaint = true;
    },
    // 关闭投诉对话框
    closeComplaintDia() {
      this.formComplaint = {}
    },
    // 操作
    toHandle(row) {
      this.complaintCode = row.complaintCode
      this.dialogVisibleHandle = true
    },
    // 提交投诉
    submitComplaint() {
      this.formComplaint.projectCode = this.checkList[0].projectCode;
      this.$http
        .post("/projectComplaint/addComplaint", this.formComplaint)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == 200) {
            this.$notify.success({
              title: "提示",
              message: "提交成功",
              showClose: true,
            });
            this.getTableData();
            this.dialogVisibleComplaint = false;
          }
        });
    },
    // 处理投诉
    submitHandle() {
      this.formHandle.complaintCode = this.complaintCode
      this.$http
        .post("/projectComplaint/update", this.formHandle)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == 200) {
            this.$notify.success({
              title: "提示",
              message: "处理成功",
              showClose: true,
            });
            this.getTableData();
            this.dialogVisibleHandle = false;
          }
        });
    },
    closeHandletDia() {
      this.formHandle = {}
    }
  },
  created() {
    // this.queryInfo.pageSize = this.$pageSize;
    // this.getListData();
  },
};
</script>

<style lang="less" scoped>
.contain {
  padding: 10px 1.25rem;
  box-sizing: border-box;

  /deep/.el-card__header {
    padding: 0;
    border-bottom: 0.0625rem solid #409eff;
  }

  .card-a {
    .choose {
      display: flex;
      justify-content: space-between;

      /deep/.el-input__inner {
        height: 2.5rem !important;
        line-height: 2.5rem !important;
      }

      /deep/.el-button {
        height: 2.5rem;
        line-height: 2.5rem;
      }
    }

    .cunstomInfo {
      margin: 1.25rem 0;
      background-color: #f7f7f7;
      padding: 1.25rem 1.875rem;
      box-sizing: border-box;
      line-height: 2.5rem;
    }

    .tab1 {
      border: 0.0625rem solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1.25rem;
      box-sizing: border-box;
      color: #fff;
      background-color: #409eff;
    }
  }

  .card-b {
    margin-top: 1.25rem;

    .tab1 {
      border: 0.0625rem solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1.25rem;
      box-sizing: border-box;
      color: #fff;
      background-color: #409eff;
    }

    .cunstomInfo {
      margin: 1.25rem 0;
      background-color: #f7f7f7;
      padding: 1.25rem 1.875rem;
      box-sizing: border-box;
      line-height: 2.5rem;
    }

    .step {

      // white-space: nowrap;
      // overflow-y: auto;
      /deep/.el-step__head.is-wait {
        color: #409eff;
        border-color: #409eff;
      }

      /deep/.el-step__title.is-wait {
        color: #000;
      }

      /deep/.el-step__description.is-wait {
        color: #000;
      }

      /deep/.el-step__line {
        background-color: #409eff;
      }
    }
  }

  .card-c {
    margin-top: 1.25rem;

    .tab1 {
      border: 0.0625rem solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1.25rem;
      box-sizing: border-box;
      color: #fff;
      background-color: #409eff;
    }

    .tab2 {
      border: 0.0625rem solid #ff7373;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1.25rem;
      box-sizing: border-box;
      color: #fff;
      background-color: #ff7373;
    }

    .chooseMember {
      position: absolute;
      top: 0.625rem;
      color: red;
      font-size: 0.75rem;
      cursor: pointer;
    }

    .todo {
      display: flex;
      justify-content: flex-end;
    }

    .memberBox {
      position: relative;

      .addIcon {
        position: absolute;
        top: 8px;
        margin-left: 10px;
        font-size: 18px;
        color: #409eff;
      }

      /deep/.el-input--small .el-input__inner {
        margin-bottom: 15px;
      }
    }
  }

  /deep/.el-button {
    border-radius: 0;
  }

  /deep/.el-dialog__header {
    background-color: #fff;
    padding: 0.625rem;
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
    border-bottom: 0.0625rem solid #efefef;
  }

  /deep/.el-dialog__header .el-dialog__title {
    line-height: 1.25rem;
    font-size: 1rem;
    color: #000;
  }
}
</style>

<style lang="less" scoped></style>